import { render } from "./ResellerInfoM.vue?vue&type=template&id=58cbe2df&scoped=true"
import script from "./ResellerInfoM.vue?vue&type=script&lang=js"
export * from "./ResellerInfoM.vue?vue&type=script&lang=js"

import "./ResellerInfoM.vue?vue&type=style&index=0&id=58cbe2df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cbe2df"]])

export default __exports__